module.exports = __webpack_public_path__ + "media/stylesheets/images/media_contents-6f4a6ed2760dbcee68c7aa91a0c569ec.jpg";